<script lang="ts" setup>
	const missions = [
		{
			title: 'Financial Security',
			description:
				'We are committed to providing financial security for Africans through insurance adoption by making it accessible, affordable, and effortless.',
			img: '/v1727082988/financial-security_q7yfry.webp',
			icon: {
				name: 'money-bag'
			},
			overlay: {
				background: 'bg-[#FF9532]',
				name: 'Frank',
				company: 'Fez Delivery Co',
				message:
					'Getting covered under the MCG team has saved us a lot of money, it has helped a lot of our employees and our riders at very critical times as well. <br /> It has also reduced the risk of paying out of pocket for repairs/ wear & tear of our vehicles.',
				quoteColor: '#FFCA99'
			}
		},
		{
			title: 'Insurance Made Easy',
			description:
				'Our intuitive platform simplifies the insurance journey, allowing you to find the right coverage, manage your policies, and file claims with ease.',
			img: '/v1727082967/Insurance_umdl8x.webp',
			icon: {
				name: 'light-bulb'
			},
			overlay: {
				background: 'bg-[#1F92D0]',
				name: 'Java',
				company: 'RiseVest',
				message:
					'On the way to work, one of our employees lost her phone. We reached out to MyCoverGenius for this, they acknowledged and empathised with us and the claim process was really smooth and faster than I expected.',
				quoteColor: '#A6D7F2'
			}
		},
		{
			title: 'Beyond Insurance',
			description:
				'We offer an experience that goes beyond traditional insurance designed to enrich and enhance your employees’ overall wellbeing and productivity.',
			img: '/v1727082966/beyond-insurance_ivr4gf.webp',
			icon: {
				name: 'briefcase',
				dir: 'document'
			},
			overlay: {
				background: 'bg-[#CC4DBB]',
				name: 'Bukola Benjamin',
				company: 'Tramango',
				message:
					'Your health plan has helped boost productivity and morale by lowering stress, and increasing employee value, I like that your support response is very prompt. I really like the ‘Visit a Hospital’ feature, as it enables our employees to easily find hospitals.',
				quoteColor: '#E8B0E1'
			}
		},
		{
			title: 'Insurance That Works',
			description:
				'We are committed to being the insurance platform that businesses can rely on. Our goal is to deliver insurance solutions that truly work, tailored to ensure comprehensive coverage every step of the way.',
			img: '/v1727082966/finance-security_zrbjd6.webp',
			icon: {
				name: 'customer-service',
				dir: 'random'
			},
			overlay: {
				background: 'bg-[#6F56DC]',
				name: 'Omolade Adeluola',
				company: 'Eghomwan Youth Development Initiative',
				message:
					"The health insurance gave me one of the best hospital around me.. The test and scan that I couldn't do for almost 1year cos of the price is what I did for 100% free.. I'm grateful. God bless you always.",
				quoteColor: '#B7AAEE'
			}
		}
	]
</script>

<template>
	<article class="flexed justify-center flex-col">
		<ui-title-header
			title="Our Mission"
			:ui="{ size: 'md:text-[3.25em] text-[2em] leading-[38.4px] md:leading-[62.4px]' }"
		/>
		<ui-pad class="w-full">
			<ul class="relative">
				<li
					v-for="(item, index) in missions"
					:key="`team-mission-${index}`"
					class="flex items-center gap-x-8 w-full py-8 relative before:absolute before:left-0 before:h-full before:bg-gray-400 before:min-h-[200px] before:top-[55%] md:before:border-l last:before:border-none before:bottom-0 my-8 before:translate-x-2"
				>
					<div class="h-[16px] w-[16px] rounded-full bg-main relative z-20 hidden md:inline-flex" />

					<div class="flex items-center md:flex-1 md:flex-nowrap flex-wrap-reverse gap-8">
						<div class="md:max-w-[360px] min-h-[280px] flex-none w-full relative group overflow-hidden">
							<lazy-nuxt-img
								:src="item.img"
								alt="founders connect"
								loading="lazy"
								class="h-full object-fill object-top w-full lg:max-h-[360px]"
								fetchpriority="low"
							/>
							<div
								class="absolute pointer-events-none h-full w-full top-0 left-0 pl-6 pt-6 pb-[30px] text-white space-y-5 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-500"
								:class="item.overlay.background"
							>
								<div class="pr-6">
									<h5 class="text-[1.25em] leading-6 font-semibold">{{ item.overlay.name }}</h5>
									<p class="text-xs font-normal">{{ item.overlay.company }}</p>
									<hr class="border-gray-200 mt-5" />
								</div>
								<p
									class="text-sm font-medium leading-[22px] max-w-[312px]"
									v-html="item.overlay.message"
								/>
								<div class="absolute bottom-0 right-0">
									<tools-icon
										dir="random"
										icon="quote-full"
										:width="120"
										:height="88.79"
										:path-fill="item.overlay.quoteColor"
									/>
								</div>
							</div>
						</div>

						<div class="flex-col justify-start flex-wrap items-start gap-5 inline-flex">
							<div
								class="md:w-[100px] w-[60px] h-[60px] md:h-[100px] inline-flex justify-center items-center bg-white rounded-full border border-gray-300"
							>
								<tools-icon
									:dir="item?.icon?.dir ?? 'random'"
									:icon="item.icon.name"
									svg-class="md:h-[60px] md:w-[60px] w-[32px] h-[32px]"
								/>
							</div>

							<div class="flex-col justify-start items-start gap-3 flex">
								<div
									class="self-stretch text-gray-700 md:text-[1.75em] text-xl leading-normal font-bold uppercase md:leading-[39.20px] md:tracking-[3.36px]"
								>
									{{ item.title }}
								</div>

								<div
									class="max-w-[790px] text-gray-600 md:text-xl text-base font-medium md:leading-[30px] leading-relaxed"
								>
									{{ item.description }}
								</div>
							</div>
						</div>
					</div>
				</li>
			</ul>
		</ui-pad>
	</article>
</template>

<style></style>
